import { NotFoundView } from "@/components/_molecules/not-found-view";
import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { lazyRoute } from "@/routes/lazy-route";

const StatusSettingsPage = lazyRoute(() => import("./status-settings.page"), "StatusSettingsPage");

export const statusSettingsRoutes = [
  {
    path: "status",
    element: (
      <FeatureFlagToggle flag="enable-status-settings-page" fallback={<NotFoundView />}>
        <StatusSettingsPage />
      </FeatureFlagToggle>
    ),
  },
];
